export default __webpack_public_path__ + "static/media/deleteHotspot.002f0c7a.svg";